<div class="flex flex-column align-items-start gap-3 align-self-stretch pb-4">
  <div class="flex justify-content-center align-items-center text-lg">
    {{ i18n.i18nLng()['EMAILNOTIFICATIONINFO'] }}
  </div>
  <div class="flex align-items-center mt-1">
    <p-checkbox inputId="email-notification" [(ngModel)]="paymentData.emailNotification" [binary]="true" size="large"/>
    <label for="email-notification" class="ml-2 text-lg">{{ i18n.i18nLng()['SENDEMAILPAYMENTNOTIFICATION'] }}</label>
  </div>
  <div class="flex flex-column gap-2 w-full">
    <label for="email-address">{{ i18n.i18nLng()['EMAILADDRESS'] }}
      @if (paymentData?.emailNotification) {
        <sup class="sps-sup">*</sup>
      }
    </label>
    <input pInputText
           id="email-address"
           [(ngModel)]="paymentData.emailAddress"
           [required]="paymentData?.emailNotification"
           [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
           [ngClass]="(paymentInvalidFlags?.emailAddress || paymentInvalidFlags.invalidEmailFormat) ? 'ng-invalid ng-dirty' : null"
           [attr.aria-invalid]="paymentInvalidFlags.emailAddress"
           [attr.aria-describedby]="paymentInvalidFlags.emailAddress ? 'email-invalid-help' : 'email-address-help'"
           (keydown)="helper.checkIllegalChar($event, ';')"
           maxlength="500"
           aria-describedby="email-address-help"
           pSize="large"/>
    @if (paymentInvalidFlags.emailAddress && paymentData?.emailNotification) {
      <small style="line-height: 1.5rem" class="text-error" role="alert" id="email-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}&nbsp;{{ i18n.i18nLng()['MULTIPLERECIPIENTSHELP'] }}</small>
    } @else {
      @if (paymentInvalidFlags.invalidEmailFormat) {
        <small style="line-height: 1.5rem" class="text-error" role="alert" id="email-invalid-help">{{ i18n.i18nLng()['INVALIDEMAILHELP'] }}</small>
      } @else {
        <small style="line-height: 1.5rem" id="email-address-help">{{ i18n.i18nLng()['MULTIPLERECIPIENTSHELP'] }}</small>
      }
    }
  </div>
</div>
